/**
 * @description
 * Roles enum
 * @enum {string}
 */
export var ROLES;
(function (ROLES) {
    ROLES["ALERT"] = "alert";
    ROLES["ALERTDIALOG"] = "alertdialog";
    ROLES["APPLICATION"] = "application";
    ROLES["ARTICLE"] = "article";
    ROLES["ASSOCIATIONLIST"] = "associationlist";
    ROLES["ASSOCIATIONLISTITEMKEY"] = "associationlistitemkey";
    ROLES["ASSOCIATIONLISTITEMVALUE"] = "associationlistitemvalue";
    ROLES["BANNER"] = "banner";
    ROLES["BLOCKQUOTE"] = "blockquote";
    ROLES["BUTTON"] = "button";
    ROLES["CAPTION"] = "caption";
    ROLES["CELL"] = "cell";
    ROLES["CHECKBOX"] = "checkbox";
    ROLES["CODE"] = "code";
    ROLES["COLUMNHEADER"] = "columnheader";
    ROLES["COMBOBOX"] = "combobox";
    ROLES["COMPLEMENTARY"] = "complementary";
    ROLES["CONTENTINFO"] = "contentinfo";
    ROLES["DEFINITION"] = "definition";
    ROLES["DELETION"] = "deletion";
    ROLES["DIALOG"] = "dialog";
    ROLES["DIRECTORY"] = "directory";
    ROLES["DOCUMENT"] = "document";
    ROLES["EMPHASIS"] = "emphasis";
    ROLES["FEED"] = "feed";
    ROLES["FIGURE"] = "figure";
    ROLES["FORM"] = "form";
    ROLES["GRID"] = "grid";
    ROLES["GRIDCELL"] = "gridcell";
    ROLES["GROUP"] = "group";
    ROLES["HEADING"] = "heading";
    ROLES["IMG"] = "img";
    ROLES["INSERTION"] = "insertion";
    ROLES["LINK"] = "link";
    ROLES["LIST"] = "list";
    ROLES["LISTBOX"] = "listbox";
    ROLES["LISTITEM"] = "listitem";
    ROLES["LOG"] = "log";
    ROLES["MAIN"] = "main";
    ROLES["MARQUEE"] = "marquee";
    ROLES["MATH"] = "math";
    ROLES["MENU"] = "menu";
    ROLES["MENUBAR"] = "menubar";
    ROLES["MENUITEM"] = "menuitem";
    ROLES["MENUITEMCHECKBOX"] = "menuitemcheckbox";
    ROLES["MENUITEMRADIO"] = "menuitemradio";
    ROLES["METER"] = "meter";
    ROLES["NAVIGATION"] = "navigation";
    ROLES["NONE"] = "none";
    ROLES["NOTE"] = "note";
    ROLES["OPTION"] = "option";
    ROLES["PARAGRAPH"] = "paragraph";
    ROLES["PRESENTATION"] = "presentation";
    ROLES["PROGRESSBAR"] = "progressbar";
    ROLES["RADIO"] = "radio";
    ROLES["RADIOGROUP"] = "radiogroup";
    ROLES["REGION"] = "region";
    ROLES["ROW"] = "row";
    ROLES["ROWGROUP"] = "rowgroup";
    ROLES["ROWHEADER"] = "rowheader";
    ROLES["SCROLLBAR"] = "scrollbar";
    ROLES["SEARCH"] = "search";
    ROLES["SEARCHBOX"] = "searchbox";
    ROLES["SEPARATOR"] = "separator";
    ROLES["SLIDER"] = "slider";
    ROLES["SPINBUTTON"] = "spinbutton";
    ROLES["STATUS"] = "status";
    ROLES["STRONG"] = "strong";
    ROLES["SUBSCRIPT"] = "subscript";
    ROLES["SUPERSCRIPT"] = "superscript";
    ROLES["SWITCH"] = "switch";
    ROLES["TAB"] = "tab";
    ROLES["TABLE"] = "table";
    ROLES["TABLIST"] = "tablist";
    ROLES["TABPANEL"] = "tabpanel";
    ROLES["TERM"] = "term";
    ROLES["TEXTBOX"] = "textbox";
    ROLES["TIME"] = "time";
    ROLES["TIMER"] = "timer";
    ROLES["TOOLBAR"] = "toolbar";
    ROLES["TOOLTIP"] = "tooltip";
    ROLES["TREE"] = "tree";
    ROLES["TREEGRID"] = "treegrid";
    ROLES["TREEITEM"] = "treeitem";
})(ROLES || (ROLES = {}));
//# sourceMappingURL=role.js.map